/**
 * Lazy-loaded icons with encapsulated Suspense boundaries.
 */
import React, { Suspense } from 'react';

// oxlint-disable-next-line @atlassian/no-restricted-imports
import { lazyForPaint } from '@atlassian/react-loosely-lazy';

const LazyAhaIconComponent = lazyForPaint(
	() => import(/* webpackChunkName: "icon-aha" */ './utils').then((m) => m.AhaIcon),
	{ moduleId: '@atlassian/rovo-connectors-config/aha/icon' },
);

const LazyAhaSearchResultIconComponent = lazyForPaint(
	() =>
		import(/* webpackChunkName: "icon-aha-search-result" */ './utils').then(
			(m) => m.AhaSearchResultIcon,
		),
	{ moduleId: '@atlassian/rovo-connectors-config/aha/search-result-icon' },
);

/**
 * Exported icons with self-contained Suspense boundaries.
 * Consumers can use these directly without wrapping in LazySuspense.
 */
export const AhaIcon = (): React.JSX.Element => (
	<Suspense fallback={null}>
		<LazyAhaIconComponent />
	</Suspense>
);

export const AhaSearchResultIcon = (): React.JSX.Element => (
	<Suspense fallback={null}>
		<LazyAhaSearchResultIconComponent />
	</Suspense>
);
